import type { ActivityKind, GroupType } from './schemas';

/** Avatar palette from the design (`PAL`). */
export const PAL = [
  '#0369a1',
  '#f59e0b',
  '#10b981',
  '#ec4899',
  '#0ea5e9',
  '#8b5cf6',
  '#ef4444',
  '#14b8a6',
] as const;

/** Deterministic avatar colour for a name (design's `colorFor`). */
export function colorFor(name: string): string {
  let h = 0;
  for (const c of name) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return PAL[h % PAL.length]!;
}

/** Up to two upper-case initials (design's `initials`). */
export function initials(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((x) => x[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

export const firstName = (name: string) => name.trim().split(/\s+/)[0] ?? name;

export const KIND_COLORS: Record<ActivityKind, { bg: string; fg: string }> = {
  Attendance: { bg: '#e6f4fc', fg: '#0369a1' },
  Workshop: { bg: '#ecfdf5', fg: '#047857' },
  Event: { bg: '#fdf2f8', fg: '#be185d' },
  Exam: { bg: '#f5f3ff', fg: '#6d28d9' },
};

export const GROUP_TYPE_COLORS: Record<GroupType, { bg: string; fg: string }> = {
  School: { bg: '#e6f4fc', fg: '#0369a1' },
  Session: { bg: '#ecfdf5', fg: '#047857' },
  Event: { bg: '#fdf2f8', fg: '#be185d' },
};
